export const ENROLLMENT_SERVICES = ["cdrn", "rdr", "ethoca"];

export const ENROLLMENT_STATUSES = [
  { id: "pending", label: "Pending" },
  { id: "needs_help", label: "Needs help" },
  { id: "active", label: "Active" },
  { id: "failed", label: "Failed" },
  { id: "unenrolled", label: "Unenrolled" },
];

export const normalizeServiceKey = (value = "") =>
  value.toString().trim().toLowerCase();

export const createEmptyDraft = () =>
  ENROLLMENT_SERVICES.reduce((acc, service) => {
    acc[service] = [];
    return acc;
  }, {});

// Every service always renders the full ENROLLMENT_STATUSES checklist below (see
// DropdownBlockEnrollments.js), so "available" statuses must match that fixed list for every
// service - narrowing it down to whatever happens to be present in `data` made the "All"/service
// checkbox report as fully checked (instead of indeterminate) whenever only some of the rendered
// statuses were selected.
export const buildAvailableStatuses = () =>
  ENROLLMENT_SERVICES.reduce((acc, service) => {
    acc[service] = ENROLLMENT_STATUSES.map(({ id }) => id);
    return acc;
  }, {});

export const draftFromFilters = (filtersValue, availableStatuses) => {
  const nextDraft = createEmptyDraft();

  if (!Array.isArray(filtersValue) || !filtersValue.length) {
    return nextDraft;
  }

  filtersValue.forEach((item) => {
    if (typeof item !== "string" || !item.includes(":")) {
      return;
    }

    const [rawService, rawStatuses = ""] = item.split(":");
    const service = normalizeServiceKey(rawService);
    const statuses = rawStatuses
      .split(",")
      .map(normalizeServiceKey)
      .filter(Boolean);

    if (!service || !ENROLLMENT_SERVICES.includes(service)) {
      return;
    }

    if (!statuses.length) {
      nextDraft[service] = [...availableStatuses[service]];
      return;
    }

    statuses.forEach((status) => {
      if (!nextDraft[service].includes(status)) {
        nextDraft[service].push(status);
      }
    });
  });

  return nextDraft;
};

export const filtersFromDraft = (draft) =>
  ENROLLMENT_SERVICES
    .filter((service) => draft[service].length)
    .map((service) => `${service}:${draft[service].join(",")}`);
